import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { 
  AgeGroupService, 
  ArrayService, 
  AuthService, 
  ChurchService, 
  DatabaseService, 
  FestivalUserService, 
  LeagueService, 
  SportTeamService
} from 'src/core/services';
import { NameValue, SportLeague } from '../../core/models';
import { PageClass } from 'src/core/classes/page';
import { Sport } from 'src/core/enums';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-migrate-sport-leagues',
  templateUrl: './migrate-sport-leagues.component.html',
  styleUrls: ['./migrate-sport-leagues.component.less', '../../core/styles/common.less']
})

export class MigrateSportLeaguesComponent extends PageClass implements OnInit {

  sportList: NameValue[];

  isLoading = true;

  migration: { serviceYear: string, sport: NameValue, years: number, result: string } = 
    { serviceYear: '', sport: null, years: 1, result: '' }

  constructor(
    protected ageGroupService: AgeGroupService,
    protected arrayService: ArrayService,
    protected authService: AuthService,
    protected churchService: ChurchService,
    protected databaseService: DatabaseService,
    protected festivalUserService: FestivalUserService,
    private router: Router,
    protected leagueService: LeagueService,
    protected sportService: SportTeamService
  ) {
      super(ageGroupService, arrayService, authService, churchService, databaseService, festivalUserService);
  }

  protected loadData = async () => {
    if (this.currentUser.isActive && !this.currentUser.isDeleted) {
      if (!this.currentUser.isAdmin) {
        this.router.navigate(['/']);
      } else {
        this.sportList = this.sportService.getSportList();
      }
    }
  }
  
  public migrateActivityFormats() {
    this.appendMigrationResult('Starting migration', true);

    this.leagueService.getLeagueList(this.migration.sport.value as unknown as Sport, this.migration.serviceYear)
      .pipe(take(1))
      .subscribe((leagues: SportLeague[]) => {

        this.appendMigrationResult(`Found ${leagues.length} sport leagues`)
        
        leagues.forEach((league: SportLeague) => {
          this.leagueService.migrateLeague(league, this.migration.years).then(() => {
            this.appendMigrationResult(`Migrated sport league ${league.displayName}`);
          });
        });
      });
  }

  private appendMigrationResult(message: string, reset: boolean = false): void {
    if (reset)
      this.migration.result = `${message}\r\n`;
    else  
      this.migration.result += `${message}\r\n`
  }

}